import {
  Checkbox,
  TableCell,
  TableRow,
  IconButton,
  Stack,
  Box,
} from "@mui/material";
import PrintDisabledIcon from "@mui/icons-material/PrintDisabled";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import OutboxIcon from "@mui/icons-material/Outbox";
import {
  strDateFormatWithTime,
  mapStatus,
  mapSubtatus,
} from "../utils/functions";
import { useNavigate } from "react-router-dom";

function ForRoutingAdminRow({
  request,
  color,
  selectedPrintLabels,
  setSelectedPrintLabels,
  columnVisibility,
}) {
  const navigate = useNavigate();

  const handleRowSelect = (orderId) => {
    setSelectedPrintLabels((prevSelected) =>
      prevSelected.includes(orderId)
        ? prevSelected.filter((id) => id !== orderId)
        : [...prevSelected, orderId]
    );
  };

  const isVisible = (dbName) =>
    columnVisibility ? !!columnVisibility[dbName] : true;

  return (
    <TableRow
      sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: color }}
    >
      {isVisible("label") && (
        <TableCell sx={{ minWidth: 80, paddingLeft: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {request.has_label ? (
              <Checkbox
                color="primary"
                checked={selectedPrintLabels.includes(request.order_id)}
                onChange={() => handleRowSelect(request.order_id)}
              />
            ) : (
              <Stack direction="row" alignItems="center" spacing={0}>
                <Checkbox
                  color="primary"
                  checked={selectedPrintLabels.includes(request.order_id)}
                  onChange={() => handleRowSelect(request.order_id)}
                />
                <IconButton
                  color="error"
                  size="small"
                  title="No se pudo obtener la etiqueta"
                >
                  <PrintDisabledIcon fontSize="small" />
                </IconButton>
              </Stack>
            )}
            {request.is_external && (
              <IconButton color="info" size="small" title="Envío asignado a mi">
                <MoveToInboxIcon fontSize="small" />
              </IconButton>
            )}
            {request.is_assigned && (
              <IconButton color="warning" size="small" title="Envío derivado">
                <OutboxIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </TableCell>
      )}

      {isVisible("actions") && (
        <TableCell>
          <IconButton
            onClick={() => navigate(`/home/order-details/${request.order_id}`)}
          >
            <i className="material-icons">add</i>
          </IconButton>
        </TableCell>
      )}

      {isVisible("created_at") && (
        <TableCell>
          {request.created_at
            ? request.created_at
            : "-"}
        </TableCell>
      )}

      {isVisible("order_id") && (
        <TableCell>{request.order_id || "-"}</TableCell>
      )}
      {isVisible("delivery_id") && (
        <TableCell>{request.delivery_id || "-"}</TableCell>
      )}
      {isVisible("total_items") && (
        <TableCell>{request.total_items || "-"}</TableCell>
      )}
      {isVisible("status") && (
        <TableCell>{mapStatus(request.status) || "-"}</TableCell>
      )}
      {isVisible("sub_status") && (
        <TableCell>{mapSubtatus(request.sub_status) || "-"}</TableCell>
      )}
      {isVisible("reference_id") && (
        <TableCell>{request.reference_id || "-"}</TableCell>
      )}
      {isVisible("master_tracking_number") && (
        <TableCell>{request.master_tracking_number || "-"}</TableCell>
      )}
      {isVisible("seller_name") && (
        <TableCell>{request.seller_name || "-"}</TableCell>
      )}
      {isVisible("courier") && <TableCell>{request.courier || "-"}</TableCell>}
      {isVisible("customer") && (
        <TableCell>{request.customer || "-"}</TableCell>
      )}
      {isVisible("commune") && <TableCell>{request.commune || "-"}</TableCell>}
      {isVisible("driver") && <TableCell>{request.driver || "-"}</TableCell>}
      {isVisible("assigned_at") && <TableCell>{request.assigned_at
            ? request.assigned_at
            : "-"}</TableCell>}
    </TableRow>
  );
}

export default ForRoutingAdminRow;
